import { useCallback } from "react";
import { getPRD5030_R01List } from "./Api_PRD5030_R01";
import { usePRD5030_R01Store } from "./Store_PRD5030_R01";
import { PRD5030_R01ResultDto } from "./Dto_PRD5030_R01";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";

interface PRD5030_R01ContentProps {
	setMessage: (message: string) => void;
}

export const Content_PRD5030_R01 = (props: PRD5030_R01ContentProps) => {
	const { setMessage } = props;

	const {
		PRD5030_R01Filter,
		setPRD5030_R01List,
	} = usePRD5030_R01Store();

	const { setLoadingSpinner } = useLoadingSpinnerStore();

	useFetchActionbarAuth("PRD5030_R01");

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		try {
			const response = await getPRD5030_R01List('', PRD5030_R01Filter);
			const newList = [...(response.data.data ?? [])] as PRD5030_R01ResultDto[];

			setPRD5030_R01List(newList);

			// 월별 12행은 항상 내려오므로, 실데이터 유무는 작업시간 합으로 판단
			const hasData = newList.some((d) => Number(d.workMin) > 0 || Number(d.downMin) > 0);
			if (hasData) {
				ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (${PRD5030_R01Filter.year}년)`);
			} else {
				showWarning('데이터가 없습니다.');
			}
		} catch (error) {
			console.error('데이터 조회 실패:', error);
			showWarning('데이터 조회에 실패했습니다.');
			setPRD5030_R01List([]);
		} finally {
			setLoadingSpinner(false);
		}
	}, [PRD5030_R01Filter, setPRD5030_R01List, setMessage, setLoadingSpinner]);

	return {
		fetchData,
	};
};
